import { combineReducers } from 'redux';

import reviewsForListing from './reviewsForListing';

const rootReviewsReducer = combineReducers({
  reviewsForListing,
});

export default rootReviewsReducer;
